import { FormInstance } from "antd/es/form";
import { Guid } from "guid-typescript";
import moment from "moment";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface ITeslimTesellumWeb_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface ITeslimTesellumWeb_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GetMyDetail: any[];
  GetMyDetail_dummy: any[];
  GetUserWithGroupDetails: any[];
  GetUserWithGroupDetails_dummy: any[];
  GetBoxDetailForMobile: any[];
  GetBoxDetailForMobile_dummy: any[];
  GetBoxById: any[];
  GetBoxById_dummy: any[];
  GetProductMuadilWithProduct: any[];
  GetProductMuadilWithProduct_dummy: any[];
  GoBack: any;
  GoBack_dummy: any;
  UpdateOrderStatusTeslimTesellum: number;
  UpdateOrderStatusTeslimTesellum_dummy: number;
  STDLogsSave: number;
  STDLogsSave_dummy: number;
  Notify: boolean;
  Notify_dummy: boolean;
  Multiply: number;
  Multiply_dummy: number;
  ReturnStringEverthing: string;
  ReturnStringEverthing_dummy: string;
  IfThenElse: boolean;
  IfThenElse_dummy: boolean;
  ReturnString3Param: string;
  ReturnString3Param_dummy: string;
  isComp411395Visible: "visible" | "hidden";
  isComp869139Visible: "visible" | "hidden";
}

export class TeslimTesellumWeb_ScreenBase extends React.PureComponent<
  ITeslimTesellumWeb_ScreenProps,
  any
> {
  teslimtesellumweb_232652_value_kuikaAutoCompleteRef: React.RefObject<any>;
  ml = [
    {
      Id: "25c1b361-4262-e567-aef0-4b8ceff8261c",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "ea2af393-7864-0865-c06a-2b07d10d3ec8",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "8882727d-65a5-4ee8-b992-0bd32ac197b9",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 592269, PropertyName: "value", Value: "Kutu ID" },
        { Id: 603251, PropertyName: "value", Value: "Malzeme Adı" },
        { Id: 599509, PropertyName: "value", Value: "Beklenen Adet" },
        { Id: 25139, PropertyName: "value", Value: "Malzeme Kodu" },
        { Id: 688483, PropertyName: "label", Value: "İptal Et" },
        { Id: 855655, PropertyName: "value", Value: "Eklenen Malzeme" },
        { Id: 232652, PropertyName: "placeholder", Value: "Choose one..." },
        {
          Id: 596397,
          PropertyName: "value",
          Value: "Malzeme Kutu İçeriği (Adet)",
        },
        { Id: 248099, PropertyName: "placeholder", Value: "15" },
        {
          Id: 482915,
          PropertyName: "value",
          Value: "Malzeme Sayısı (Kutu Bazlı Adet)",
        },
        { Id: 647267, PropertyName: "placeholder", Value: "15" },
        { Id: 459628, PropertyName: "label", Value: "Siparişi Tamamla" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.teslimtesellumweb_232652_value_kuikaAutoCompleteRef =
      React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GetMyDetail: [],
      GetUserWithGroupDetails: [],
      GetBoxDetailForMobile: [],
      GetBoxById: [],
      GetProductMuadilWithProduct: [],
      GoBack: "",
      UpdateOrderStatusTeslimTesellum: 0,
      STDLogsSave: 0,
      Notify: false,
      Multiply: 0,
      IfThenElse: false,
      isComp411395Visible: "hidden",
      isComp869139Visible: "hidden",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("teslimtesellumweb", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    if (true) {
      await this.TeslimTesellumWebPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("teslimtesellumweb", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("teslimtesellumweb", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.TeslimTesellumWebPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      teslimtesellumweb_232652_value:
        this.state.GetBoxDetailForMobile?.at?.(0)?.productId ?? undefined,
      teslimtesellumweb_248099_value: undefined,
      teslimtesellumweb_647267_value: undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  TeslimTesellumWebPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      username_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
      UserName_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
      BoxIdentifier_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.BoxIdentifier ??
          this.props.screenInputs.boxidentifier,
        "number"
      ),
      BoxIdentifier_3: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.BoxIdentifier ??
          this.props.screenInputs.boxidentifier,
        "number"
      ),
      RealProduct_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetBoxDetailForMobile !== undefined
            ? stateVars.GetBoxDetailForMobile?.length > 0
              ? stateVars.GetBoxDetailForMobile[0].productId
              : null
            : this.state.GetBoxDetailForMobile?.length > 0
            ? this.state.GetBoxDetailForMobile[0].productId
            : null
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TeslimTesellumWeb/TeslimTesellumWebPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetMyDetail = result?.data.getMyDetail;
    stateVars.GetUserWithGroupDetails = result?.data.getUserWithGroupDetails;
    stateVars.isComp411395Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].orderDelete
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].orderDelete
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp869139Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].userGroupCreate
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].userGroupCreate
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.GetBoxDetailForMobile = result?.data.getBoxDetailForMobile;
    formVars.teslimtesellumweb_317259_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetBoxDetailForMobile !== undefined
        ? stateVars.GetBoxDetailForMobile?.length > 0
          ? stateVars.GetBoxDetailForMobile[0].boxIdentifier
          : null
        : this.state.GetBoxDetailForMobile?.length > 0
        ? this.state.GetBoxDetailForMobile[0].boxIdentifier
        : null
    );
    formVars.teslimtesellumweb_150662_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetBoxDetailForMobile !== undefined
        ? stateVars.GetBoxDetailForMobile?.length > 0
          ? stateVars.GetBoxDetailForMobile[0].productName
          : null
        : this.state.GetBoxDetailForMobile?.length > 0
        ? this.state.GetBoxDetailForMobile[0].productName
        : null
    );
    formVars.teslimtesellumweb_840290_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetBoxDetailForMobile !== undefined
        ? stateVars.GetBoxDetailForMobile?.length > 0
          ? stateVars.GetBoxDetailForMobile[0].expectedQuantity
          : null
        : this.state.GetBoxDetailForMobile?.length > 0
        ? this.state.GetBoxDetailForMobile[0].expectedQuantity
        : null
    );
    formVars.teslimtesellumweb_479571_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetBoxDetailForMobile !== undefined
        ? stateVars.GetBoxDetailForMobile?.length > 0
          ? stateVars.GetBoxDetailForMobile[0].productCode
          : null
        : this.state.GetBoxDetailForMobile?.length > 0
        ? this.state.GetBoxDetailForMobile[0].productCode
        : null
    );
    formVars.teslimtesellumweb_232652_value =
      stateVars.GetBoxDetailForMobile !== undefined
        ? stateVars.GetBoxDetailForMobile?.length > 0
          ? stateVars.GetBoxDetailForMobile[0].productId
          : null
        : this.state.GetBoxDetailForMobile?.length > 0
        ? this.state.GetBoxDetailForMobile[0].productId
        : null;
    formVars.teslimtesellumweb_232652_options =
      stateVars.GetProductMuadilWithProduct;
    stateVars.GetBoxById = result?.data.getBoxById;
    stateVars.GetProductMuadilWithProduct =
      result?.data.getProductMuadilWithProduct;

    formVars.teslimtesellumweb_232652_value =
      stateVars.GetBoxDetailForMobile !== undefined
        ? stateVars.GetBoxDetailForMobile?.length > 0
          ? stateVars.GetBoxDetailForMobile[0].productId
          : null
        : this.state.GetBoxDetailForMobile?.length > 0
        ? this.state.GetBoxDetailForMobile[0].productId
        : null;
    formVars.teslimtesellumweb_232652_options =
      stateVars.GetProductMuadilWithProduct;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TeslimTesellumWebPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TeslimTesellumWebPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.teslimtesellumweb_317259_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetBoxDetailForMobile !== undefined
        ? stateVars.GetBoxDetailForMobile?.length > 0
          ? stateVars.GetBoxDetailForMobile[0].boxIdentifier
          : null
        : this.state.GetBoxDetailForMobile?.length > 0
        ? this.state.GetBoxDetailForMobile[0].boxIdentifier
        : null
    );

    formVars.teslimtesellumweb_150662_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetBoxDetailForMobile !== undefined
        ? stateVars.GetBoxDetailForMobile?.length > 0
          ? stateVars.GetBoxDetailForMobile[0].productName
          : null
        : this.state.GetBoxDetailForMobile?.length > 0
        ? this.state.GetBoxDetailForMobile[0].productName
        : null
    );

    formVars.teslimtesellumweb_840290_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetBoxDetailForMobile !== undefined
        ? stateVars.GetBoxDetailForMobile?.length > 0
          ? stateVars.GetBoxDetailForMobile[0].expectedQuantity
          : null
        : this.state.GetBoxDetailForMobile?.length > 0
        ? this.state.GetBoxDetailForMobile[0].expectedQuantity
        : null
    );

    formVars.teslimtesellumweb_479571_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetBoxDetailForMobile !== undefined
        ? stateVars.GetBoxDetailForMobile?.length > 0
          ? stateVars.GetBoxDetailForMobile[0].productCode
          : null
        : this.state.GetBoxDetailForMobile?.length > 0
        ? this.state.GetBoxDetailForMobile[0].productCode
        : null
    );

    stateVars.isComp411395Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].orderDelete
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].orderDelete
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp869139Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].userGroupCreate
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].userGroupCreate
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    formVars.teslimtesellumweb_232652_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetBoxDetailForMobile !== undefined
        ? stateVars.GetBoxDetailForMobile?.length > 0
          ? stateVars.GetBoxDetailForMobile[0].productId
          : null
        : this.state.GetBoxDetailForMobile?.length > 0
        ? this.state.GetBoxDetailForMobile[0].productId
        : null
    );

    stateVars.dataSource_232652 =
      stateVars.GetProductMuadilWithProduct ??
      this.state.GetProductMuadilWithProduct;
    stateVars.dataSource_232652 =
      stateVars.GetProductMuadilWithProduct ??
      this.state.GetProductMuadilWithProduct;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  TeslimTesellumWebComponent_8753_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TeslimTesellumWebComponent_688483_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      NewOrderStatus_0: ReactSystemFunctions.convertToTypeByName(5, "number"),
      OrderedValue_0: ReactSystemFunctions.convertToTypeByName(0, "number"),
      BoxIdentifier_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.BoxIdentifier ??
          this.props.screenInputs.boxidentifier,
        "number"
      ),
      CreatedAt_1: ReactSystemFunctions.convertToTypeByName(
        moment().format("YYYY-MM-DDTHH:mm:ss"),
        "Date"
      ),
      CreatedUserId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetMyDetail !== undefined
            ? stateVars.GetMyDetail?.length > 0
              ? stateVars.GetMyDetail[0].id
              : null
            : this.state.GetMyDetail?.length > 0
            ? this.state.GetMyDetail[0].id
            : null
        ),
        "Guid"
      ),
      EventId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetBoxById !== undefined
            ? stateVars.GetBoxById?.length > 0
              ? stateVars.GetBoxById[0].id
              : null
            : this.state.GetBoxById?.length > 0
            ? this.state.GetBoxById[0].id
            : null
        ),
        "Guid"
      ),
      LogStatus_1: ReactSystemFunctions.convertToTypeByName(1, "number"),
      LogText_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName(
          "Sipariş İptal Edildi",
          "string"
        ),
        "string"
      ),
      Id_1: ReactSystemFunctions.convertToTypeByName(
        Guid.create().toString(),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    stateVars.Confirm = await ReactSystemFunctions.confirmation(
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "030a963c_f8c2_3b87_3629_bb4f055314fa_confirmation",
        this.defaultML,
        "Siparişi iptal etmek istediğinize emin misiniz?"
      ),
      "poppins",
      "Sipariş İptal",
      "confirmation",
      "#ff2424"
    );

    if (stateVars.Confirm) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "TeslimTesellumWeb/TeslimTesellumWebComponent_688483_onClick",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.UpdateOrderStatusTeslimTesellum =
        result?.data.updateOrderStatusTeslimTesellum;
      stateVars.STDLogsSave = result?.data.stdLogsSave;
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.TeslimTesellumWebComponent_688483_onClick1_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TeslimTesellumWebComponent_688483_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "b0b6b19c_5bb8_fdd1_9dc7_bb48cf7e07c7_notify",
        this.defaultML,
        "Sipariş İptal Edildi"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("bottom-right", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );
    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TeslimTesellumWebComponent_459628_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "teslimtesellumweb_248099_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "teslimtesellumweb_248099_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "teslimtesellumweb_647267_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "teslimtesellumweb_647267_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Multiply = await ReactSystemFunctions.multiply(
      ReactSystemFunctions.value(
        this,
        ReactSystemFunctions.value(
          this,
          "teslimtesellumweb_248099_value",
          "value",
          "",
          "",
          ""
        )
      ),
      ReactSystemFunctions.value(
        this,
        ReactSystemFunctions.value(
          this,
          "teslimtesellumweb_647267_value",
          "value",
          "",
          "",
          ""
        )
      )
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.TeslimTesellumWebComponent_459628_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  TeslimTesellumWebComponent_459628_onClick_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.TeslimTesellumWebComponent_459628_onClick_if11_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  TeslimTesellumWebComponent_459628_onClick_if1f1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {};

    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.TeslimTesellumWebComponent_459628_onClick_if1f11_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TeslimTesellumWebComponent_459628_onClick_if1f11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      NewOrderStatus_0: ReactSystemFunctions.convertToTypeByName(3, "number"),
      OrderedValue_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetBoxById !== undefined
            ? stateVars.GetBoxById?.length > 0
              ? stateVars.GetBoxById[0].expectedQuantity
              : null
            : this.state.GetBoxById?.length > 0
            ? this.state.GetBoxById[0].expectedQuantity
            : null
        ),
        "number"
      ),
      BoxIdentifier_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.BoxIdentifier ??
          this.props.screenInputs.boxidentifier,
        "number"
      ),
      CreatedAt_1: ReactSystemFunctions.convertToTypeByName(
        moment().format("YYYY-MM-DDTHH:mm:ss"),
        "Date"
      ),
      CreatedUserId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetMyDetail !== undefined
            ? stateVars.GetMyDetail?.length > 0
              ? stateVars.GetMyDetail[0].id
              : null
            : this.state.GetMyDetail?.length > 0
            ? this.state.GetMyDetail[0].id
            : null
        ),
        "Guid"
      ),
      EventId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetBoxById !== undefined
            ? stateVars.GetBoxById?.length > 0
              ? stateVars.GetBoxById[0].id
              : null
            : this.state.GetBoxById?.length > 0
            ? this.state.GetBoxById[0].id
            : null
        ),
        "Guid"
      ),
      LogStatus_1: ReactSystemFunctions.convertToTypeByName(1, "number"),
      LogText_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName(
          "Sipariş Teslim Edildi",
          "string"
        ),
        "string"
      ),
      Id_1: ReactSystemFunctions.convertToTypeByName(
        Guid.create().toString(),
        "Guid"
      ),
    };

    stateVars.Confirm = await ReactSystemFunctions.confirmation(
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "e47152f2_0c91_62bf_2e41_0cadf4fc9dd4_confirmation",
        this.defaultML,
        "Siparişi tamamlamak istediğinize emin misiniz?"
      ),
      "poppins",
      "Siparişi Tamamla",
      "confirmation",
      "#246dff"
    );

    if (stateVars.Confirm) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "TeslimTesellumWeb/TeslimTesellumWebComponent_459628_onClick_if1f11_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.UpdateOrderStatusTeslimTesellum =
        result?.data.updateOrderStatusTeslimTesellum;
      stateVars.STDLogsSave = result?.data.stdLogsSave;
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.TeslimTesellumWebComponent_459628_onClick_if1f12_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TeslimTesellumWebComponent_459628_onClick_if1f12_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "f6fc439f_612d_ffba_7c2d_a697f827ee7d_notify",
        this.defaultML,
        "Sipariş Tamamlandı"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("bottom-right", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );
    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  TeslimTesellumWebComponent_459628_onClick_if1e1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.TeslimTesellumWebComponent_459628_onClick_if1e11_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  TeslimTesellumWebComponent_459628_onClick_if1e1f1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {};

    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.TeslimTesellumWebComponent_459628_onClick_if1e1f11_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TeslimTesellumWebComponent_459628_onClick_if1e1f11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      NewOrderStatus_0: ReactSystemFunctions.convertToTypeByName(4, "number"),
      OrderedValue_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.state.Multiply),
        "number"
      ),
      BoxIdentifier_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.BoxIdentifier ??
          this.props.screenInputs.boxidentifier,
        "number"
      ),
      parameter1_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName(
          "Kısmi olarak teslim edildi:",
          "string"
        ),
        "string"
      ),
      parameter2_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.Multiply),
        "string"
      ),
      CreatedAt_2: ReactSystemFunctions.convertToTypeByName(
        moment().format("YYYY-MM-DDTHH:mm:ss"),
        "Date"
      ),
      CreatedUserId_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetMyDetail !== undefined
            ? stateVars.GetMyDetail?.length > 0
              ? stateVars.GetMyDetail[0].id
              : null
            : this.state.GetMyDetail?.length > 0
            ? this.state.GetMyDetail[0].id
            : null
        ),
        "Guid"
      ),
      EventId_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetBoxById !== undefined
            ? stateVars.GetBoxById?.length > 0
              ? stateVars.GetBoxById[0].id
              : null
            : this.state.GetBoxById?.length > 0
            ? this.state.GetBoxById[0].id
            : null
        ),
        "Guid"
      ),
      LogStatus_2: ReactSystemFunctions.convertToTypeByName(1, "number"),
      LogText_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, stateVars.ReturnStringEverthing),
        "string"
      ),
      Id_2: ReactSystemFunctions.convertToTypeByName(
        Guid.create().toString(),
        "Guid"
      ),
    };

    stateVars.Confirm = await ReactSystemFunctions.confirmation(
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "5edfa837_0b31_58f4_1543_8e8ae67ec353_confirmation",
        this.defaultML,
        "Siparişi tamamlamak istediğinize emin misiniz?"
      ),
      "poppins",
      "Siparişi Tamamla",
      "confirmation",
      "#246dff"
    );

    if (stateVars.Confirm) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "TeslimTesellumWeb/TeslimTesellumWebComponent_459628_onClick_if1e1f11_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.UpdateOrderStatusTeslimTesellum =
        result?.data.updateOrderStatusTeslimTesellum;
      stateVars.ReturnStringEverthing = result?.data.returnStringEverthing;
      stateVars.STDLogsSave = result?.data.stdLogsSave;
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.TeslimTesellumWebComponent_459628_onClick_if1e1f12_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TeslimTesellumWebComponent_459628_onClick_if1e1f12_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "58d6f6b1_5c9b_3093_2cee_cd1a06c6b971_notify",
        this.defaultML,
        "Sipariş Tamamlandı"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("bottom-right", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );
    stateVars.GoBack = await ReactSystemFunctions.goBack(this, "");

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  TeslimTesellumWebComponent_459628_onClick_if1e1e1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "e729a32d_400d_b3d8_de01_bc22d6696791_notify",
        this.defaultML,
        "Beklenen adetten daha fazla malzeme eklemesi yapılamaz!"
      ),
      ReactSystemFunctions.convertToTypeByName("warning", "string"),
      ReactSystemFunctions.convertToTypeByName("bottom-right", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  TeslimTesellumWebComponent_459628_onClick_if1e11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isLessThan(
        ReactSystemFunctions.value(this, this.state.Multiply),
        ReactSystemFunctions.value(
          this,
          stateVars.GetBoxDetailForMobile !== undefined
            ? stateVars.GetBoxDetailForMobile?.length > 0
              ? stateVars.GetBoxDetailForMobile[0].expectedQuantity
              : null
            : this.state.GetBoxDetailForMobile?.length > 0
            ? this.state.GetBoxDetailForMobile[0].expectedQuantity
            : null
        )
      )
    ) {
      isErrorOccurred =
        await this.TeslimTesellumWebComponent_459628_onClick_if1e1f1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.TeslimTesellumWebComponent_459628_onClick_if1e1e1();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  TeslimTesellumWebComponent_459628_onClick_if11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, this.state.Multiply),
        ReactSystemFunctions.value(
          this,
          stateVars.GetBoxDetailForMobile !== undefined
            ? stateVars.GetBoxDetailForMobile?.length > 0
              ? stateVars.GetBoxDetailForMobile[0].expectedQuantity
              : null
            : this.state.GetBoxDetailForMobile?.length > 0
            ? this.state.GetBoxDetailForMobile[0].expectedQuantity
            : null
        )
      )
    ) {
      isErrorOccurred =
        await this.TeslimTesellumWebComponent_459628_onClick_if1f1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.TeslimTesellumWebComponent_459628_onClick_if1e1();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  TeslimTesellumWebComponent_459628_onClick_else1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.TeslimTesellumWebComponent_459628_onClick_else11_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  TeslimTesellumWebComponent_459628_onClick_else1f1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {};

    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.TeslimTesellumWebComponent_459628_onClick_else1f11_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TeslimTesellumWebComponent_459628_onClick_else1f11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "teslimtesellumweb_232652_value",
          "value",
          "GetProductMuadilWithProduct",
          "id",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "teslimtesellumweb_232652_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      NewOrderStatus_0: ReactSystemFunctions.convertToTypeByName(3, "number"),
      OrderedValue_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetBoxById !== undefined
            ? stateVars.GetBoxById?.length > 0
              ? stateVars.GetBoxById[0].expectedQuantity
              : null
            : this.state.GetBoxById?.length > 0
            ? this.state.GetBoxById[0].expectedQuantity
            : null
        ),
        "number"
      ),
      BoxIdentifier_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.BoxIdentifier ??
          this.props.screenInputs.boxidentifier,
        "number"
      ),
      parameter1_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName(
          "Sipariş muadil ürün kullanılarak teslim edildi:",
          "string"
        ),
        "string"
      ),
      parameter2_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "teslimtesellumweb_232652_value",
            "value",
            "GetProductMuadilWithProduct",
            "id",
            "productName"
          )
        ),
        "string"
      ),
      CreatedAt_2: ReactSystemFunctions.convertToTypeByName(
        moment().format("YYYY-MM-DDTHH:mm:ss"),
        "Date"
      ),
      CreatedUserId_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetMyDetail !== undefined
            ? stateVars.GetMyDetail?.length > 0
              ? stateVars.GetMyDetail[0].id
              : null
            : this.state.GetMyDetail?.length > 0
            ? this.state.GetMyDetail[0].id
            : null
        ),
        "Guid"
      ),
      EventId_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetBoxById !== undefined
            ? stateVars.GetBoxById?.length > 0
              ? stateVars.GetBoxById[0].id
              : null
            : this.state.GetBoxById?.length > 0
            ? this.state.GetBoxById[0].id
            : null
        ),
        "Guid"
      ),
      LogStatus_2: ReactSystemFunctions.convertToTypeByName(1, "number"),
      LogText_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, stateVars.ReturnStringEverthing),
        "string"
      ),
      Id_2: ReactSystemFunctions.convertToTypeByName(
        Guid.create().toString(),
        "Guid"
      ),
    };

    stateVars.Confirm = await ReactSystemFunctions.confirmation(
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "e9b2b563_7b9b_c4d4_d345_4d1973d285db_confirmation",
        this.defaultML,
        "Siparişi tamamlamak istediğinize emin misiniz?"
      ),
      "poppins",
      "Siparişi Tamamla",
      "confirmation",
      "#246dff"
    );

    if (stateVars.Confirm) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "TeslimTesellumWeb/TeslimTesellumWebComponent_459628_onClick_else1f11_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.UpdateOrderStatusTeslimTesellum =
        result?.data.updateOrderStatusTeslimTesellum;
      stateVars.ReturnStringEverthing = result?.data.returnStringEverthing;
      stateVars.STDLogsSave = result?.data.stdLogsSave;
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.TeslimTesellumWebComponent_459628_onClick_else1f12_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TeslimTesellumWebComponent_459628_onClick_else1f12_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "62bdde0a_d567_cb13_d4b1_5068112c842e_notify",
        this.defaultML,
        "Sipariş Tamamlandı"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("bottom-right", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );
    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  TeslimTesellumWebComponent_459628_onClick_else1e1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.TeslimTesellumWebComponent_459628_onClick_else1e11_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  TeslimTesellumWebComponent_459628_onClick_else1e1f1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {};

    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.TeslimTesellumWebComponent_459628_onClick_else1e1f11_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TeslimTesellumWebComponent_459628_onClick_else1e1f11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "teslimtesellumweb_232652_value",
          "value",
          "GetProductMuadilWithProduct",
          "id",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "teslimtesellumweb_232652_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      NewOrderStatus_0: ReactSystemFunctions.convertToTypeByName(4, "number"),
      OrderedValue_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.state.Multiply),
        "number"
      ),
      BoxIdentifier_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.BoxIdentifier ??
          this.props.screenInputs.boxidentifier,
        "number"
      ),
      logText_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName(
          "Muadil ürün kullanılarak kısmi teslim edildi:",
          "string"
        ),
        "string"
      ),
      productName_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "teslimtesellumweb_232652_value",
            "value",
            "GetProductMuadilWithProduct",
            "id",
            "productName"
          )
        ),
        "string"
      ),
      orderedQuantity_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.state.Multiply),
        "number"
      ),
      CreatedAt_2: ReactSystemFunctions.convertToTypeByName(
        moment().format("YYYY-MM-DDTHH:mm:ss"),
        "Date"
      ),
      CreatedUserId_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetMyDetail !== undefined
            ? stateVars.GetMyDetail?.length > 0
              ? stateVars.GetMyDetail[0].id
              : null
            : this.state.GetMyDetail?.length > 0
            ? this.state.GetMyDetail[0].id
            : null
        ),
        "Guid"
      ),
      EventId_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetBoxById !== undefined
            ? stateVars.GetBoxById?.length > 0
              ? stateVars.GetBoxById[0].id
              : null
            : this.state.GetBoxById?.length > 0
            ? this.state.GetBoxById[0].id
            : null
        ),
        "Guid"
      ),
      LogStatus_2: ReactSystemFunctions.convertToTypeByName(1, "number"),
      LogText_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, stateVars.ReturnString3Param),
        "string"
      ),
      Id_2: ReactSystemFunctions.convertToTypeByName(
        Guid.create().toString(),
        "Guid"
      ),
    };

    stateVars.Confirm = await ReactSystemFunctions.confirmation(
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "4ecda48f_c375_2d73_a9a2_c7e6797e13de_confirmation",
        this.defaultML,
        "Siparişi tamamlamak istediğinize emin misiniz?"
      ),
      "poppins",
      "Siparişi Tamamla",
      "confirmation",
      "#246dff"
    );

    if (stateVars.Confirm) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "TeslimTesellumWeb/TeslimTesellumWebComponent_459628_onClick_else1e1f11_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.UpdateOrderStatusTeslimTesellum =
        result?.data.updateOrderStatusTeslimTesellum;
      stateVars.ReturnString3Param = result?.data.returnString3Param;
      stateVars.STDLogsSave = result?.data.stdLogsSave;
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.TeslimTesellumWebComponent_459628_onClick_else1e1f12_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TeslimTesellumWebComponent_459628_onClick_else1e1f12_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "1600b390_60dc_c359_53c5_511fff79cf9b_notify",
        this.defaultML,
        "Sipariş Tamamlandı"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("bottom-right", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );
    stateVars.GoBack = await ReactSystemFunctions.goBack(this, "");

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  TeslimTesellumWebComponent_459628_onClick_else1e1e1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "d05dd5aa_4fe1_c549_6e2b_605b024f0c52_notify",
        this.defaultML,
        "Beklenen adetten daha fazla malzeme eklemesi yapılamaz!"
      ),
      ReactSystemFunctions.convertToTypeByName("warning", "string"),
      ReactSystemFunctions.convertToTypeByName("bottom-right", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  TeslimTesellumWebComponent_459628_onClick_else1e11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isLessThan(
        ReactSystemFunctions.value(this, this.state.Multiply),
        ReactSystemFunctions.value(
          this,
          stateVars.GetBoxDetailForMobile !== undefined
            ? stateVars.GetBoxDetailForMobile?.length > 0
              ? stateVars.GetBoxDetailForMobile[0].expectedQuantity
              : null
            : this.state.GetBoxDetailForMobile?.length > 0
            ? this.state.GetBoxDetailForMobile[0].expectedQuantity
            : null
        )
      )
    ) {
      isErrorOccurred =
        await this.TeslimTesellumWebComponent_459628_onClick_else1e1f1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.TeslimTesellumWebComponent_459628_onClick_else1e1e1();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  TeslimTesellumWebComponent_459628_onClick_else11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, this.state.Multiply),
        ReactSystemFunctions.value(
          this,
          stateVars.GetBoxDetailForMobile !== undefined
            ? stateVars.GetBoxDetailForMobile?.length > 0
              ? stateVars.GetBoxDetailForMobile[0].expectedQuantity
              : null
            : this.state.GetBoxDetailForMobile?.length > 0
            ? this.state.GetBoxDetailForMobile[0].expectedQuantity
            : null
        )
      )
    ) {
      isErrorOccurred =
        await this.TeslimTesellumWebComponent_459628_onClick_else1f1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.TeslimTesellumWebComponent_459628_onClick_else1e1();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  TeslimTesellumWebComponent_459628_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "teslimtesellumweb_232652_value",
            "value",
            "GetProductMuadilWithProduct",
            "id",
            "id"
          )
        ),
        ReactSystemFunctions.value(
          this,
          stateVars.GetBoxDetailForMobile !== undefined
            ? stateVars.GetBoxDetailForMobile?.length > 0
              ? stateVars.GetBoxDetailForMobile[0].productId
              : null
            : this.state.GetBoxDetailForMobile?.length > 0
            ? this.state.GetBoxDetailForMobile[0].productId
            : null
        )
      )
    ) {
      isErrorOccurred =
        await this.TeslimTesellumWebComponent_459628_onClick_if1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.TeslimTesellumWebComponent_459628_onClick_else1();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
  }
}
